<template>
  <v-dialog v-model="internalDialog" max-width="500px" @keydown.esc="close">
    <v-card>
      <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="confirmPrint">
        <v-card-title>
          <span class="headline">Imprimir Etiqueta TMS</span>
        </v-card-title>

        <v-card-text>
          <v-container class="mt-0 mb-0">
            <v-row>
              <v-col cols="12">
                <p class="mb-4">
                  Orden de envío: <strong>{{ shipment_order?.code }}</strong>
                </p>
                <p v-if="shipment_order?.tms_code" class="mb-4">
                  Código TMS: <strong>{{ shipment_order?.tms_code }}</strong>
                </p>

                <v-combobox
                  v-model="selected_printer"
                  :loading="loading_printers"
                  name="printer"
                  item-title="name"
                  item-value="id"
                  :items="printers"
                  label="Impresora*"
                  autocomplete="off"
                  :rules="[rules.requiredComboBox]"
                  clearable
                ></v-combobox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" variant="text" @click="close"> Cancelar </v-btn>
          <v-btn color="success" variant="text" type="submit" :loading="loading"> Imprimir </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { packagesService } from "@/libs/ws/packagesService";
import { printerService } from "@/libs/ws/printerService";
import { shipmentOrderService } from "@/libs/ws/shipmentOrderService";
import ValidMixin from "@/mixins/ValidMixin.vue";
import BrowserPrintMixin from "@/mixins/BrowserPrint.vue";

export default {
  mixins: [ValidMixin, BrowserPrintMixin],
  props: {
    modelValue: Boolean,
    shipment_order: Object,
  },
  emits: ["update:modelValue", "print"],
  data() {
    return {
      valid: false,
      selected_printer: null,
      loading: false,
      loading_printers: false,
      printers: [],
    };
  },
  computed: {
    internalDialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    modelValue(val) {
      if (val) {
        // Se abrió el modal, resetear el formulario
        this.selected_printer = null;
        this.loadPrinters();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.internalDialog = false;
      this.selected_printer = null;
    },
    loadPrinters() {
      this.loading_printers = true;

      printerService
        .filter()
        .then((response) => {
          if (response && response.status) {
            this.printers = response.result.list;

            if (this.printers.length === 1) {
              this.selected_printer = this.printers[0];
              console.log("Auto-seleccionada impresora:", this.selected_printer.name);
            }
          } else {
            this.toast.error("Error al cargar las impresoras");
          }
        })
        .catch((error) => {
          console.error("Error loading printers:", error);
          this.toast.error("Error al cargar las impresoras");
        })
        .finally(() => {
          this.loading_printers = false;
        });
    },

    async printLabelZPL() {
      try {
        this.loading = true;
        const code = this.shipment_order?.code;

        console.log("Iniciando impresión de etiquetas TMS ZPL...", code);

        const response = await packagesService.print_label_zpl({
          shipment_order_code: code,
        });

        if (response.status) {
          const etiquetasZPL = response.result;

          if (!this.selected_printer) {
            this.handleError("No se ha seleccionado una impresora.");
            return;
          }

          // Imprimir cada etiqueta ZPL con delay para evitar conflictos
          for (let i = 0; i < etiquetasZPL.length; i++) {
            await this.printSingleZPL(this.selected_printer, etiquetasZPL[i], i);
          }

          this.toast.success("Etiquetas TMS impresas correctamente");
          this.close();
        } else {
          this.handleError(response?.msg || response?.message || "Error de comunicación con el servidor");
        }
      } catch (error) {
        console.error("Error al imprimir etiquetas TMS ZPL:", error);
        this.handleError("Ha ocurrido un error al imprimir las etiquetas.");
      } finally {
        this.loading = false;
      }
    },

    handleError(message) {
      this.toast.error(message);
    },

    async confirmPrint() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      // Llamar al método de impresión ZPL
      await this.printLabelZPL();
    },
  },
};
</script>

<style scoped>
.title-modal {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
</style>
